export default __webpack_public_path__ + "static/media/refund.c961c453.md";